export const filterCases = (biomaterials) => {
  const cases = {};

  biomaterials.forEach(({ caseObj }) => {
    cases[caseObj.id] = caseObj;
  });

  return Object.values(cases);
};
